import axios from 'axios';

const getRespostas = params => axios.get('/cotacoes/matriz/respostas', { params });

export default {
  getRespostas,
};
